import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/gua";

export default function LatestSection() {
  const latest = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="最新补档"
            title="刚整理完的考古内容"
            desc="每一条都标注了时间线与关键节点，可以按自己的节奏慢慢看，不用担心错过前情。"
          />
          <Link
            to="/heji?sort=new"
            className="flex w-fit items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 whitespace-nowrap"
          >
            更多补档
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {latest.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      </div>
    </section>
  );
}